// Wrapper fino sobre las Cloud Functions de catálogo (Postgres/Neon).
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const listarCatalogoFn = httpsCallable(functions, 'listarCatalogo');
const listarAuditoriaCuraduriaFn = httpsCallable(functions, 'listarAuditoriaCuraduria');
const actualizarCuraduriaFn = httpsCallable(functions, 'actualizarCuraduria');
const obtenerHistorialPreciosFn = httpsCallable(functions, 'obtenerHistorialPrecios');
const obtenerEspecificacionesFn = httpsCallable(functions, 'obtenerEspecificaciones');
const listarUsadosFn = httpsCallable(functions, 'listarUsados');
const obtenerModeloFn = httpsCallable(functions, 'obtenerModelo');
const obtenerMayoresDiferenciasFn = httpsCallable(functions, 'obtenerMayoresDiferencias');
const obtenerEvolucionSemanalFn = httpsCallable(functions, 'obtenerEvolucionSemanal');
const obtenerInformeCargasFn = httpsCallable(functions, 'obtenerInformeCargas');
const obtenerEspecificacionesPorIdFn = httpsCallable(functions, 'obtenerEspecificacionesPorId');
const actualizarEspecificacionesFn = httpsCallable(functions, 'actualizarEspecificaciones');
const actualizarIdentidadEspecificacionFn = httpsCallable(functions, 'actualizarIdentidadEspecificacion');
const listarEspecificacionesFn = httpsCallable(functions, 'listarEspecificaciones');
const renombrarIdentidadVersionesFn = httpsCallable(functions, 'renombrarIdentidadVersiones');
const listarIdentidadesSpecsFn = httpsCallable(functions, 'listarIdentidadesSpecs');
const obtenerMisClasificacionesFn = httpsCallable(functions, 'obtenerMisClasificaciones');
const guardarMiClasificacionFn = httpsCallable(functions, 'guardarMiClasificacion');
const detectarNormalizacionFn = httpsCallable(functions, 'detectarNormalizacion', { timeout: 120000 });
const detectarNormalizacionModelosNuevosFn = httpsCallable(functions, 'detectarNormalizacionModelosNuevos', { timeout: 180000 });
const confirmarMergeNormalizacionFn = httpsCallable(functions, 'confirmarMergeNormalizacion');
const ejecutarRespaldoCuraduriaAhoraFn = httpsCallable(functions, 'ejecutarRespaldoCuraduriaAhora', { timeout: 120000 });
const obtenerEstadoRespaldoCuraduriaFn = httpsCallable(functions, 'obtenerEstadoRespaldoCuraduria');
const restaurarCuraduriaDesdeBackupFn = httpsCallable(functions, 'restaurarCuraduriaDesdeBackup', { timeout: 120000 });
const generarPropuestasCuraduriaAhoraFn = httpsCallable(functions, 'generarPropuestasCuraduriaAhora', { timeout: 300000 });
const listarPropuestasCuraduriaFn = httpsCallable(functions, 'listarPropuestasCuraduria');
const resolverPropuestaCuraduriaFn = httpsCallable(functions, 'resolverPropuestaCuraduria');
const resolverPropuestasCuraduriaMasivoFn = httpsCallable(functions, 'resolverPropuestasCuraduriaMasivo', { timeout: 120000 });

// { autos: [...], ultimaFecha: 'YYYY-MM-DD' | null }
export async function listarCatalogo({ desde, hasta, todos } = {}) {
  const result = await listarCatalogoFn({ desde, hasta, todos });
  return result.data;
}

export async function listarAuditoriaCuraduria(campo) {
  const result = await listarAuditoriaCuraduriaFn({ campo });
  return result.data.modelos;
}

// marca es obligatorio; model/modelDetail acotan el alcance (marca sola =
// toda la marca, +model = todas las versiones de ese modelo, +modelDetail =
// una sola versión). soloVacios sólo pisa filas donde alguno de los campos
// enviados está vacío. camposExtra se mergea (no reemplaza) el JSONB existente.
export async function actualizarCuraduria({ marca, model, modelDetail, campos, camposExtra, soloVacios } = {}) {
  const result = await actualizarCuraduriaFn({ marca, model, modelDetail, campos, camposExtra, soloVacios });
  return result.data.count;
}

// operaciones: [{ id, marca?, model? }] — renombra marca y/o model de una o
// más versiones. Si el nuevo valor colisiona con una versión que ya existe,
// el backend fusiona automáticamente (mueve snapshots/specs, conserva los
// campos curados existentes del destino) en vez de fallar.
// Devuelve [{ id, ok, merged?, mergedIntoId?, error? }] por operación.
export async function renombrarIdentidadVersiones(operaciones) {
  const result = await renombrarIdentidadVersionesFn({ operaciones });
  return result.data.resultados;
}

// [{ marca, modelo }] — todas las identidades marca+modelo con ficha técnica.
export async function listarIdentidadesSpecs() {
  const result = await listarIdentidadesSpecsFn();
  return result.data.identidades;
}

export async function obtenerHistorialPrecios(marca, model, modelDetail) {
  const result = await obtenerHistorialPreciosFn({ marca, model, modelDetail });
  return result.data;
}

export async function obtenerEspecificaciones(marca, modelo, version) {
  const result = await obtenerEspecificacionesFn({ marca, modelo, version });
  return result.data.specs;
}

// { usados: [...], hasMore }
export async function listarUsados({ marca, modelo, tokens, anios, limit, offset } = {}) {
  const result = await listarUsadosFn({ marca, modelo, tokens, anios, limit, offset });
  return result.data;
}

export async function obtenerModelo(id) {
  const result = await obtenerModeloFn({ id });
  return result.data.modelo;
}

// null si nunca se ha generado el reporte semanal
export async function obtenerMayoresDiferencias() {
  const result = await obtenerMayoresDiferenciasFn();
  return result.data.data;
}

// { cargas: [{ loadedAt, total, porMarca: {marca: n} }, ...] } — orden cronológico asc
export async function obtenerEvolucionSemanal(semanas) {
  const result = await obtenerEvolucionSemanalFn({ semanas });
  return result.data.cargas;
}

// { fechasUsadas, resumenPorMarca, ultimaCarga: {loadedAt, marcas:[{marca,total,totalModelos,modelos}]},
//   comparativoMarcas: [{marca, actual:{modelos,versiones}, anterior:{modelos,versiones}}], penultimaFecha }
export async function obtenerInformeCargas(dias) {
  const result = await obtenerInformeCargasFn({ dias });
  return result.data;
}

// Resuelve una identidad (marca+model+modelDetail) al snapshot de precio
// más reciente en TODA la historia — reemplaza el patrón de "buscar el doc
// más reciente en Firestore" que usaban DetalleLista.js/Comparadormodelos.js.
// null si la identidad no existe (ya no se puede resolver un auto guardado).
export async function resolverModeloActual(marca, model, modelDetail) {
  const { version, historial } = await obtenerHistorialPrecios(marca, model, modelDetail);
  if (!version) return null;
  const ultimo = historial[historial.length - 1];
  return {
    id: String(version.id),
    marca: version.marca,
    model: version.model,
    modelDetail: version.modelDetail,
    categoria: version.categoria,
    subcategoria: version.subcategoria,
    tipomotor: version.tipomotor,
    origen: version.origen,
    segmento: version.segmento,
    combustible: version.combustible,
    traccion: version.traccion,
    ...(version.camposExtra || {}),
    tiposprecio: ultimo?.tiposprecio || [],
    precio: ultimo?.precio || [],
    date_add: ultimo?.date_add ?? null,
  };
}

export async function obtenerEspecificacionesPorId(id) {
  const result = await obtenerEspecificacionesPorIdFn({ id });
  return result.data.ficha;
}

export async function actualizarEspecificaciones(id, form) {
  await actualizarEspecificacionesFn({ id, form });
}

export async function actualizarIdentidadEspecificacion(id, marca, modelo, version) {
  await actualizarIdentidadEspecificacionFn({ id, marca, modelo, version });
}

// { specs: [...], total, marcas: [...], pageSize }
export async function listarEspecificaciones({ marca, page } = {}) {
  const result = await listarEspecificacionesFn({ marca, page });
  return result.data;
}

// Subclasificación privada del usuario — no la ve nadie más.
// { [vehicleVersionId]: clasificacion }
export async function obtenerMisClasificaciones() {
  const result = await obtenerMisClasificacionesFn();
  return result.data.clasificaciones;
}

// clasificacion vacío/null borra la clasificación. Devuelve el valor guardado (o null si se borró).
export async function guardarMiClasificacion(vehicleVersionId, clasificacion) {
  const result = await guardarMiClasificacionFn({ vehicleVersionId, clasificacion });
  return result.data.clasificacion;
}

// Reporte de posibles duplicados por typo/variación mínima de escritura —
// { candidatos: [{keepId, mergeId, keep:{marca,model,modelDetail,ultimaFecha}, merge:{...}, similitud, camposQueSeCompletan}], totalCandidatos, totalVersiones }
export async function detectarNormalizacion() {
  const result = await detectarNormalizacionFn();
  return result.data;
}

// Fusiona mergeId dentro de keepId (mueve precios/specs, completa campos curados vacíos, borra la fila duplicada).
export async function confirmarMergeNormalizacion(keepId, mergeId) {
  await confirmarMergeNormalizacionFn({ keepId, mergeId });
}

// Versiones "nuevas" (primer precio dentro de `dias`) que probablemente son
// el mismo auto que otra versión activa ya existente, con la marca/modelo
// escrito distinto (letra cambiada, palabras en otro orden). `umbral`
// 0-1 (default 0.8). Los pares se confirman con confirmarMergeNormalizacion.
// { candidatos: [{keepId,mergeId,nuevo:{marca,model,modelDetail,primeraFecha},similar:{marca,model,modelDetail,ultimaFecha},similitud}], totalCandidatos, totalNuevos }
export async function detectarNormalizacionModelosNuevos({ dias, umbral } = {}) {
  const result = await detectarNormalizacionModelosNuevosFn({ dias, umbral });
  return result.data;
}

// Respaldo de curaduría (categoria/tipomotor/origen/etc.) — copia de
// seguridad que corre sola cada noche, más este disparador manual por si
// se quiere respaldar justo después de curar algo importante.
// { count, backedUpAt }
export async function ejecutarRespaldoCuraduriaAhora() {
  const result = await ejecutarRespaldoCuraduriaAhoraFn();
  return result.data;
}

// { count, ultimoRespaldo: 'ISO'|null }
export async function obtenerEstadoRespaldoCuraduria() {
  const result = await obtenerEstadoRespaldoCuraduriaFn();
  return result.data;
}

// Restaura categoria/subcategoria/tipomotor/origen/combustible/traccion/
// segmento desde el respaldo. marca acota a una marca; sin marca hay que
// pasar confirmarTodos=true para restaurar todo el catálogo.
export async function restaurarCuraduriaDesdeBackup({ marca, confirmarTodos } = {}) {
  const result = await restaurarCuraduriaDesdeBackupFn({ marca, confirmarTodos });
  return result.data.count;
}

// Autocompletado de curaduría (categoria/tipomotor/origen faltantes) —
// propuestas por señal (ficha técnica, mismo modelo, marca conocida),
// nunca se aplican solas.
export async function generarPropuestasCuraduriaAhora() {
  const result = await generarPropuestasCuraduriaAhoraFn();
  return result.data.generadas;
}

// { propuestas: [{id, vehicleVersionId, campo, valorPropuesto, confianza, fuente, estado, vehiculo}] }
export async function listarPropuestasCuraduria({ estado, campo } = {}) {
  const result = await listarPropuestasCuraduriaFn({ estado, campo });
  return result.data.propuestas;
}

// decision: 'aprobado' | 'rechazado'. valorFinal opcional (si el usuario editó el valor propuesto).
export async function resolverPropuestaCuraduria(id, decision, valorFinal) {
  await resolverPropuestaCuraduriaFn({ id, decision, valorFinal });
}

export async function resolverPropuestasCuraduriaMasivo(ids, decision) {
  const result = await resolverPropuestasCuraduriaMasivoFn({ ids, decision });
  return result.data.resueltas;
}
